import * as React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import {
  useAtom,
  useAtomValue,
  useSetAtom,
} from 'infrastructure/state/jotai.wrapper'
import {
  existingPresentationsDeleteParams,
  flowIdsAtom,
  presentationsTreeAtom,
} from './atoms'
import { GDriveLogin } from '../googleApis/GDriveLogin'
import { Second } from './Second'
import { Third } from './Third'
import { FilesForGradeTable } from './FilesForGradeTable'
import { useGetTreeById } from '../../../reducers/trees_hooks'
import { FlowStatusGroup } from '../../contentService/FlowStatusGroup'
import { BorderedContainer } from '../../utility/Containers'
import { useAllPresentationsUpdates, useResetPresentationsTree } from './hooks'
import { DeleteButton, OutlinedButton } from 'shared/ui'
import { NodeOperationsButton } from './NodeOperationsButton'

export function UpdatePresentationsSlides({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })
  useSetAtom(presentationsTreeAtom)(tree)

  return (
    <div>
      <h2>Update Presentation from Google Slides</h2>
      <hr />
      <GDriveLogin />
      <hr />
      <FlowStatus />
      <Stack direction="column" spacing={2} width={'100%'}>
        <Second />
        <Third />
        <UpdateSection />
        <DeletePresentationsButton />
      </Stack>
      <FilesForGradeTable />
    </div>
  )
}

function FlowStatus() {
  const [flowIds, setFlowIds] = useAtom(flowIdsAtom)
  const resetTree = useResetPresentationsTree()

  const onStatusDelete = (flowId: string) => {
    setFlowIds((prev) => prev.filter((id) => id !== flowId))
  }

  if (!flowIds.length) return null
  return (
    <BorderedContainer>
      <FlowStatusGroup
        flowIds={flowIds}
        onFlowDelete={onStatusDelete}
        completedItems={[
          <OutlinedButton key="resetTree" onClick={resetTree}>
            Reset Tree
          </OutlinedButton>,
        ]}
      />
    </BorderedContainer>
  )
}

function UpdateSection() {
  const updates = useAllPresentationsUpdates()
  return (
    <Box>
      <Typography mb={1}>Update Lessons by Files and folders</Typography>
      <NodeOperationsButton operations={updates} confTitle="Update Nodes">
        Update Nodes
      </NodeOperationsButton>
    </Box>
  )
}

function DeletePresentationsButton() {
  const deleteParams = useAtomValue(existingPresentationsDeleteParams)
  return (
    <Box>
      <NodeOperationsButton
        operations={deleteParams}
        confTitle={`Delete all ${deleteParams.length} presentations`}
        ButtonComp={DeleteButton}
      >
        Delete {deleteParams.length} Presentations
      </NodeOperationsButton>
    </Box>
  )
}
